export enum WebsocketAppointmentActionEnum
{
    patientEnter = 1,
    medicEvasion = 2,
    patientEvasion = 3,
    endMedicalCare = 4,
}